
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1590579470580",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "7777",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M512 1024c-281.6 0-512-230.4-512-512s230.4-512 512-512 512 230.4 512 512S793.6 1024 512 1024zM512 64C262.4 64 64 262.4 64 512s198.4 448 448 448 448-198.4 448-448S761.6 64 512 64z",
        "p-id": "7778"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M627.2 313.6c25.6 25.6 38.4 57.6 38.4 102.4 0 32-6.4 64-25.6 83.2C640 505.6 620.8 524.8 582.4 556.8 569.6 569.6 563.2 576 556.8 588.8 550.4 601.6 544 620.8 544 640l0 12.8L467.2 652.8 467.2 640c0-25.6 6.4-51.2 12.8-64 12.8-19.2 38.4-51.2 83.2-89.6L576 467.2c12.8-19.2 19.2-32 19.2-51.2 0-25.6-6.4-44.8-19.2-57.6C563.2 345.6 537.6 339.2 512 339.2 486.4 339.2 460.8 352 448 371.2 435.2 384 428.8 409.6 428.8 441.6L352 441.6c0-51.2 12.8-89.6 44.8-121.6 32-32 70.4-44.8 121.6-44.8C563.2 275.2 601.6 288 627.2 313.6zM544 704c12.8 6.4 12.8 19.2 12.8 38.4 0 12.8-6.4 25.6-12.8 38.4-12.8 6.4-25.6 12.8-38.4 12.8-12.8 0-25.6-6.4-38.4-12.8-12.8-12.8-12.8-19.2-12.8-38.4 0-12.8 6.4-25.6 12.8-38.4 6.4-6.4 19.2-12.8 38.4-12.8C524.8 684.8 537.6 691.2 544 704z",
        "p-id": "7779"
      }
    }
  ]
})
    }
  